module.exports = __webpack_public_path__ + "static/media/danger.2d36692a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/danger.svg
// module id = 1243
// module chunks = 21